































































































































import {Component, Vue, Prop} from "vue-property-decorator";
import * as Resource from "../../api/Resource";
import {mapActions} from "vuex";
import {TogglePayload} from "../../store/modules/app/state";
import {Topup} from "../../api/config/Transactions";

@Component({
  methods: {
    ...mapActions("app", ["toggleGlobalSnackBar"]),
  },
})
export default class CreateUser extends Vue {
  @Prop() payload!: Topup;
  email = "";
  loading = false;
  toggleGlobalSnackBar!: (payload: TogglePayload) => void;

  activePicker = null;
  dateOfBirthMenu = false;

  userCred = {
    displayName: "",
    phone: "",
    email: "",
    role: "",
    birthDate: null,
    profilePhotoUrl: "",
    isBanned: false,
    isInvited: false,
    emailVerified: false,
    enableDiscountsSms: true,
    enableRemindersSms: true,
    enablePromotionsSms: true,
    enableDiscountsEmail: true,
    enableRemindersEmail: true,
    enablePromotionsEmail: true,
    enableNewsAndUpdateSms: true,
    enableNewsAndUpdateEmail: true,
    // @ts-ignore
    ...this.transaction,
  };

  checkBoxFields1 = {
    isBanned: {
      value: false,
      label: "isBanned",
    },
    isInvited: {
      value: false,
      label: "isInvited",
    },
  };

  checkBoxFields2 = {
    emailVerified: {
      value: false,
      label: "emailVerified",
    },
    enableDiscountsSms: {
      value: true,
      label: "enableDiscountsSms",
    },
    enableRemindersSms: {
      value: true,
      label: "enableRemindersSms",
    },
    enablePromotionsSms: {
      value: true,
      label: "enablePromotionsSms",
    },
    enableDiscountsEmail: {
      value: true,
      label: "enableDiscountsEmail",
    },
    enableRemindersEmail: {
      value: true,
      label: "enableRemindersEmail",
    },
    enablePromotionsEmail: {
      value: true,
      label: "enablePromotionsEmail",
    },
    enableNewsAndUpdateSms: {
      value: true,
      label: "enableNewsAndUpdateSms",
    },
    enableNewsAndUpdateEmail: {
      value: true,
      label: "enableNewsAndUpdateEmail",
    },
  };
  roleSelectItems = ["user", "admin"];
  performTransactionLoading = false;

  transaction: any = {};

  mounted() {
    this.transaction = this.$route?.params?.payload;
  }

  goBack() {
    this.$router.back();
  }

  save() {
    this.dateOfBirthMenu = false;
  }

  async performTransaction() {
    this.performTransactionLoading = true;
    const id = this.transaction.id || "";

    try {
      const res = await Resource.transactions.performTransaction(id).pipe();
      console.log(res);
      this.performTransactionLoading = false;
      this.toggleGlobalSnackBar({
        show: true,
        type: "success",
        text: "Trasction performed successfully!",
      });
    } catch (e) {
      console.log("ERROR PERFORMING PAYMENT TRANSACTION: ", e);
      this.performTransactionLoading = false;
      this.toggleGlobalSnackBar({
        show: true,
        type: "error",
        text: "There is no successful payment for this topup",
      });
    }
  }
}
